
import React, { useEffect, useState } from 'react'
import ReactDOM from 'react-dom'
import { CascadePicker } from 'antd-mobile'


const AiCascadePicker:any = {}

AiCascadePicker.prompt = (options) => {
    return new Promise((resolve, reject) => {
        const _div = document.getElementById('ai-cascade-picker')
        if( _div ) {
            AiCascadePicker.destroy()
        }
        let div = document.createElement('div')
        div.id = 'ai-cascade-picker'
        document.body.appendChild(div);

        const AiCascadePickerHook = props => {
            const [visible, setVisible] = useState(false)
            useEffect(() => {
                setVisible(true)
            },[])
            const onConfirm = value => {
                if( options?.onConfirm ) {
                    options.onConfirm(value)
                }
                resolve(value)
                setVisible(false)
                AiCascadePicker.destroy()
            }
            const onCancel = () => {
                if( options?.onCancel ) {
                    options.onCancel()
                }
                setVisible(false)
                AiCascadePicker.destroy()
                resolve(null)
            }
            return  <CascadePicker {...options} visible={visible} onCancel={onCancel} onConfirm={onConfirm} />
        }
        ReactDOM.render(<AiCascadePickerHook />, div)
    })
}

AiCascadePicker.destroy = () => {
    const div = document.getElementById('ai-cascade-picker')
    if( div ) {
        ReactDOM.render(null, div)
        document.body.removeChild(div)
    }
}

export default AiCascadePicker